export const navbarData = [
	{
		to: 'about',
		text: 'About',
	},
	{
		to: 'clients',
		text: 'skills',
	},
	{
		to: 'projects',
		text: 'Projects',
	},
];
